/**
 * 3D tilt on frame-motion icons (mouse / touch)
 */
export function initFrameMotion3d() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const icons = document.querySelectorAll('[data-frame-3d]');
  if (!icons.length) return;

  const maxTilt = 16;

  icons.forEach((el) => {
    const stage = el.querySelector('.mkt-frame-motion__stage');
    if (!stage) return;

    const setTilt = (x, y) => {
      stage.style.setProperty('--fm-rx', `${y}deg`);
      stage.style.setProperty('--fm-ry', `${x}deg`);
    };

    const reset = () => {
      setTilt(0, 0);
      el.classList.remove('is-tilting');
    };

    const onMove = (clientX, clientY) => {
      const rect = el.getBoundingClientRect();
      const px = (clientX - rect.left) / rect.width - 0.5;
      const py = (clientY - rect.top) / rect.height - 0.5;

      setTilt(px * maxTilt * 2, -py * maxTilt * 2);
      el.classList.add('is-tilting');
    };

    el.addEventListener('mousemove', (e) => onMove(e.clientX, e.clientY));
    el.addEventListener('mouseleave', reset);

    el.addEventListener(
      'touchmove',
      (e) => {
        const touch = e.touches[0];
        if (!touch) return;
        onMove(touch.clientX, touch.clientY);
      },
      { passive: true }
    );
    el.addEventListener('touchend', reset);
  });
}
